export const LocalPreferenceIds = {
  VESSEL_SCHEDULE_GROUP_BY_VVD: 'VESSEL_SCHEDULE_GROUP_BY_VVD',
  SELECTED_BOTTOM_TAB_INDEX_FOR_PLAN: 'SELECTED_BOTTOM_TAB_INDEX_FOR_PLAN',
  SELECTED_RIGHT_TAB: 'SELECTED_RIGHT_TAB'
};
